import { styled } from '@abyss/web/tools/styled';
import { IconSymbol } from '@abyss/web/ui/IconSymbol';
import { TextInput } from '@abyss/web/ui/TextInput';
import React, { FC } from 'react';

const StyledButton = styled('button', {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: '40px ',
  height: '38px',
  background: '$primary1',
  border: 'none',
  borderRadius: '4px 0px 0px 4px',

  '&:hover,&:active': {
    backgroundColor: '$interactive1',
    color: '$white',
    borderColor: '$interactive1',
  },

  '&:focus-visible': {
    zIndex: 1,
  },

  variants: {
    increment: {
      true: {
        borderRadius: '0px 4px 4px 0px',
      },
    },
    isDisabled: {
      true: {
        background: '$gray4',
        '&:active,&:hover': {
          background: '$gray4',
        },
        cursor: 'not-allowed',
        '&:focus-visible,&:focus': {
          background: '$gray4',
        },
      },
    },
  },
});

const Wrapper = styled('div', {
  display: 'flex',
  gap: '0px',
});

interface Props {
  hiddenLabel: string;
  disabled: boolean;
  value: string;
  leftBtnDisabled: boolean;
  rightBtnDisabled: boolean;
  placeholder: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onIncrement: () => void;
  onDecrement: () => void;
}

export const NumberSelector: FC<Props> = ({
  hiddenLabel,
  disabled,
  value,
  leftBtnDisabled,
  rightBtnDisabled,
  placeholder,
  onChange,
  onIncrement,
  onDecrement,
}) => {
  return (
    <Wrapper>
      <StyledButton
        isDisabled={disabled || leftBtnDisabled}
        disabled={disabled || leftBtnDisabled}
        onClick={onDecrement}
      >
        <IconSymbol icon="remove" size="18px" color="$white" />
      </StyledButton>
      <TextInput
        label={hiddenLabel}
        placeholder={placeholder}
        hideLabel
        value={value}
        onChange={onChange}
        isDisabled={disabled}
        css={{
          'abyss-text-input-root': {
            width: 'auto',
            padding: '0px',
          },
          'abyss-text-input': {
            borderRadius: '0px',
            width: '50px',
            textAlign: 'center',
            padding: '0px',
          },
        }}
      />
      <StyledButton
        increment
        isDisabled={disabled || rightBtnDisabled}
        disabled={disabled || rightBtnDisabled}
        onClick={onIncrement}
      >
        <IconSymbol icon="add" size="18px" color="$white" />
      </StyledButton>
    </Wrapper>
  );
};
